import React, { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AppContext } from '../../context/AppContext';
import { EventoComunitario } from '../../models/types';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 700px;
  margin: 40px auto;
  padding: 32px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
`;
const Title = styled.h2`
  color: #101325;
  margin-bottom: 16px;
`;
const Field = styled.div`
  margin-bottom: 18px;
`;
const Label = styled.label`
  font-weight: bold;
  color: #101325;
`;
const Value = styled.div`
  color: #222;
  font-size: 1.1rem;
`;
const ButtonBar = styled.div`
  margin-top: 32px;
  display: flex;
  gap: 16px;
`;
const Button = styled.button`
  background: #101325;
  color: #fff;
  border: none;
  padding: 10px 22px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  &:hover { background: #1a1f3d; }
`;

const EventoDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data } = useContext(AppContext);
  const [evento, setEvento] = useState<EventoComunitario | null>(null);

  useEffect(() => {
    if (!id) return;
    const found = data.eventosComunitarios.find(e => e.id === id);
    setEvento(found || null);
  }, [id, data.eventosComunitarios]);

  if (!evento) {
    return <Container><Title>Evento no encontrado</Title><Button onClick={() => navigate('/eventos')}>Volver</Button></Container>;
  }

  return (
    <Container>
      <Title>Detalle del Evento</Title>
      <Field>
        <Label>Nombre:</Label>
        <Value>{evento.nombre}</Value>
      </Field>
      <Field>
        <Label>Descripción:</Label>
        <Value>{evento.descripcion}</Value>
      </Field>
      <Field>
        <Label>Tipo:</Label>
        <Value>{evento.tipo.replace('_', ' ')}</Value>
      </Field>
      <Field>
        <Label>Fecha:</Label>
        <Value>{evento.fecha}</Value>
      </Field>
      <Field>
        <Label>Hora de inicio:</Label>
        <Value>{evento.horaInicio}</Value>
      </Field>
      <Field>
        <Label>Circuito:</Label>
        <Value>{evento.circuito || 'N/A'}</Value>
      </Field>
      <Field>
        <Label>Organizador:</Label>
        <Value>{evento.organizador}</Value>
      </Field>
      <Field>
        <Label>Estado:</Label>
        <Value>{evento.estado}</Value>
      </Field>
      <ButtonBar>
        <Button onClick={() => navigate('/eventos')}>Volver</Button>
      </ButtonBar>
    </Container>
  );
};

export default EventoDetail;
